export default {
    data() {
        return{
            showHidden: false
        }
    },
    methods: {
        show() {
            this.showHidden = !this.showHidden
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/diversifiedTransport3/diversifiedTransport.vue.js